import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eventDetailsFormat'
})
export class EventDetailsFormatPipe implements PipeTransform {
  transform(detail: string): string {
    if (!detail) return '';

    let result = detail.split('\n');
    let html = result.map((p: string) => `<span>${p}</span>`).join('<br/>');

    return html;
  }
}
